/* unplugin-vue-components disabled */import { render } from "./RegisterDialog.vue?vue&type=template&id=1fdbd748&scoped=true"
import script from "./RegisterDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDialog.vue?vue&type=script&lang=js"

import "./RegisterDialog.vue?vue&type=style&index=0&id=1fdbd748&lang=scss&scoped=true"

import exportComponent from "/var/workhome/jenkins/jenkins_home/workspace/prod-vue-mt-comp-sso/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdbd748"]])

export default __exports__